import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { GranicaBledu } from './components/GranicaBledu';
import { AppProviders } from './providers/AppProviders';
import './i18n';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Granica NAD routerem i dostawcami: awaria któregokolwiek z nich też ma
        skończyć się ekranem z akcją, a nie białą stroną. */}
    <GranicaBledu>
      <BrowserRouter>
        <AppProviders>
          <App />
        </AppProviders>
      </BrowserRouter>
    </GranicaBledu>
  </React.StrictMode>
);
